import styled from 'styled-components'
import Colors from 'builder/styles/colors'
import Typography, { FontWeights } from 'builder/styles/typography'
import Sizes from 'builder/styles/sizes'
import Media from 'builder/styles/media'

export const ContentBannerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: ${Sizes.XS} 20px;
  background-color: ${Colors.Green10};
  border-radius: 4px;

  ${Media.Phone`
    padding: ${Sizes.XS} ${Sizes.S};
    margin: 20px 20px 0;
    width: unset;
  `};
`

export const ContentBannerText = styled.p`
  ${Typography.Caption}
  ${FontWeights.Regular};
  color: ${Colors.Green70};

  span {
    ${FontWeights.DemiBold};
  }

  ${Media.Phone`
    text-align: center;
  `};
`
